import React from "react";

/**
 * Contexto de apariencia (doc 0390, FT-5).
 *
 * Antes solo exponía `toggleColorMode`. Ahora transporta además el tema activo,
 * los temas disponibles y la acción para cambiarlo.
 *
 * FORMA DEL VALOR — se conserva la que ya existía:
 *
 *   const { colorMode } = useContext(ColorModeContext);
 *   colorMode.toggleColorMode();
 *
 * El proveedor entrega `{ colorMode }`, no el objeto pelado. Es una envoltura
 * heredada, pero cambiarla obligaría a tocar todos los consumidores actuales sin
 * ganar nada. Se respeta.
 *
 * REPARTO DE ALCANCE (decisiones D9 y D10):
 *
 *   toggleColorMode / setMode  -> preferencia PERSONAL, cualquier usuario
 *   setTheme                   -> tema de la EMPRESA, solo quien administra ajustes
 *
 * `setTheme` está aquí y no en la página de configuración porque el cambio debe
 * verse al instante en toda la aplicación, no solo en la pantalla que lo dispara.
 */
const ColorModeContext = React.createContext({
  toggleColorMode: () => {},
  setMode: () => {},
  setTheme: async () => {},
  refreshTheme: async () => {},
  mode: "light",
  themeSlug: null,
  themeId: null,
  themes: [],
  tokens: []
});

export default ColorModeContext;
